<template>
  <div :class="{ 'password-input': type === 'password' }">
    <input
      v-model="inputValue"
      :type="typeComp"
      :placeholder="placeholder"
      :disabled="disabled"
      :autocomplete="autocomplete"
      :class="['w-input', { error: isError }]"
      @blur="$emit('blur')"
    />
    <button
      v-if="type === 'password'"
      class="password-status"
      type="button"
      @click="onClickPasswordStatus"
    >
      {{ hidePassword ? 'Hide' : 'Show' }}
    </button>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue'

  const props = defineProps({
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'one-time-code',
    },
    isError: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
    },
  })

  const emit = defineEmits(['input', 'blur'])

  const hidePassword = ref(false)

  const typeComp = computed(() => {
    if (props.type === 'password') {
      return hidePassword.value ? 'text' : 'password'
    }
    return props.type
  })

  const inputValue = computed({
    get: () => props.value,
    set: (value) => emit('input', value),
  })

  const onClickPasswordStatus = () => {
    hidePassword.value = !hidePassword.value
  }
</script>

<style lang="scss" scoped>
  .w-input {
    width: 100%;
    height: 54px;
    padding: 0 20px;
    border-radius: 8px;
    border: 1px solid transparent;
    background-color: #2f2f2f;
    color: #a5a5a5;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    outline: none;
    &:focus {
      border: 1px solid transparent;
    }
    &.error {
      border: 1px solid #f93950;
    }
  }
  .w-input::placeholder {
    color: #a5a5a5;
  }
  .password-input {
    position: relative;
  }
  .password-status {
    position: absolute;
    right: 20px;
    top: 15px;
    font-size: 16px;
    color: #fff;
    line-height: 24px;
  }
</style>
